'use strict';

const textBoxTemplate = require('components/ui/field_text_box/templates/desktop/main.html');
const createCvv2Factory = require('./main_creator');

module.exports = createCvv2Factory({
    modelClass: require('./model'),
    template: textBoxTemplate,
    fieldOptions: Odigeo.CreditCard.fields.cvv2,
    name: 'cvv2_field',
});
